import { ReactElement } from "react";

import "./view-executed-customers.scss";
import BreadcrumbComponent from "../../components/breadcrumb-component/breadcrumb-component";
import { Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import CustomTable from "../../components/custom-table/custom-table";
import CustomSearch from "../../components/custom-search/custom-search";
import { Link } from "react-router-dom";

const ViewExecutedCustomers: React.FC = (): ReactElement => {
  const columns: ColumnsType<any> = [
    {
      title: "#",
      dataIndex: "id",
      key: "id",
      sorter: (a, b) => a.id - b.id,
    },
    {
      title: "Full  name",
      dataIndex: "fullName",
      key: "fullName",
      sorter: (a, b) => a.fullName.length - b.fullName.length,
      fixed: "left",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      sorter: (a, b) => a.email.length - b.email.length,
    },
    {
      title: "Account",
      dataIndex: "account",
      key: "account",
      sorter: (a, b) => a.account.length - b.account.length,
      render: (text) => <Link to="">{text}</Link>
    },
    {
      title: "Mobile number",
      dataIndex: "mobile",
      key: "mobile",
      sorter: (a, b) => a.mobile.length - b.mobile.length,
    }
  ];

  return (
    <section className="upload-customers-container flex column">
      <BreadcrumbComponent />

      <div className="users-table">
        <div className="title flex align-center justify-space-between">
          <p>File data</p>
          <div className="images flex align-center">
            <CustomSearch />
            <Tooltip placement="topLeft" title="Columns settings">
              <img src={"/images/grid.svg"} alt="grid" />
            </Tooltip>
            <Tooltip placement="topLeft" title="Export">
              <img src={"/images/export.svg"} alt="export-customers" />
            </Tooltip>
          </div>
        </div>
        <CustomTable columns={columns} data={[]} showPagination={false} />
        <div className="buttons-container flex justify-flex-end">
          <button>Execute</button>
        </div>
      </div>
    </section>
  );
};

export default ViewExecutedCustomers;
